module.exports = __webpack_public_path__ + "img/center.4cff748f.png";